
<template>
<div class='monitor_right' :class="{'closeBtn':pageshow}">
  <div class="topDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>河道水情</span>
      </div>
      <div class="more">
        <!-- 乡镇检索 -->
         <div class="townSearch">
          <el-input @change="getStatisticsRiverWater" size="small" placeholder="请输入终端名称" v-model="staname" clearable>
            <i @click="getStatisticsRiverWater" slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="chartMain" v-loading="loading1" ref="toptable">
      <el-table :data="tableData" ref="riverTable" style="width: 100%" :max-height="tableHeight" @row-click="changeSt" highlight-current-row :row-class-name="reservoirWaterRowClass"  :cell-style="warningTimeStyle">
        <el-table-column type="index" align="center" label="序号" min-width="60"></el-table-column>
        <el-table-column prop="stnm" label="终端名称" align="center" min-width="120" sortable>
          <template slot-scope="scope" >
            <el-tooltip  effect="light" :content="scope.row.stcd" placement="top" popper-class="hiddenOverflow">
              <span style="cursor:pointer">{{scope.row.stnm}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="addvnm" label="乡镇" align="center" :width="cellWidth" sortable></el-table-column>
        <el-table-column prop="water" label="水位" align="center" sortable :sort-method="sortChange1">
          <template slot-scope="scope">
            <span>{{scope.row.water_Str}} </span>
            <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
            <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
            <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
          </template>
        </el-table-column>
        <el-table-column prop="overflowWarningWater" label="超警戒" align="center" sortable :sort-method="sortMethod"></el-table-column>
        <el-table-column prop="timeStr" label="时间" align="center" :width="cellWidth"></el-table-column>
      </el-table>
    </div>
  </div>
  <div class="centerDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>{{ stnm}}</span>
      </div>
      <div class="more">
      </div>
    </div>
    <div class="chartMain">
      <div class="riverDiv" v-loading="loading3">
        <div id="gcxlineChart"></div>
        <!-- <div class="chartname">{{stnm}}</div> -->
      </div>
    </div>
  </div>
  <div class="showBtn flexC"  @click="showpage"><i class="el-icon-caret-right" :class="{'tran180':pageshow}"></i></div>
  <div class="showMapBtn flexC" :class="{'radioOpen':showRadioDiv}" @mouseover="showRadioDiv = true" @mouseout="showRadioDiv=false">
    <i class="el-icon-coin" v-show="!showRadioDiv"></i>
    <div class="navMain" v-show="showRadioDiv">
      <el-radio-group v-model="mapType" @change="radioChange">
        <el-radio :label="3">水利影像图</el-radio>
        <el-radio :label="1">水利交通图</el-radio>
        <el-radio :label="5">水利地形图</el-radio>
      </el-radio-group>
    </div>
  </div>
</div>
</template>

<script>
import api from '@/api/monitor_ptcopy'
export default {
  components: {},
  data () {
    return {
      staname: '',
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      BeginTime: '',
      EndTime: '',
      tableData: [],
      tableHeight: '300',
      topWater: 0, // 闸上水位
      bomWater: 0, // 潮位
      stid: '', // 当前测站编码
      stnm: '', // 当前测站
      overflowWarningWater: 0, // 当前测站超汛限
      pageshow: false,
      timer: null,
      cellWidth: '60', // 表格cell宽度
      perRowHeight: 0,
      showRadioDiv: false,
      mapType: 3,
      minSortNum: 0 // 排序默认超汛限最小数字
    }
  },
  computed: {},
  watch: {},
  methods: {
    sortChange1 (a, b) {
      // return a.water - b.water
      let bsort = b.water === undefined ? -10 : b.water
      let asort = a.water === undefined ? -10 : a.water
      return bsort - asort
    },
    radioChange () {
      this.$emit('changeMap', this.mapType)
    },
    showpage () {
      this.pageshow = !this.pageshow
      this.$emit('reRight', this.pageshow)
    },
    setRow (id) {
      let tableDom = this.$refs.riverTable
      tableDom.tableData.forEach((item, index) => {
        if (item.id === id) {
          tableDom.setCurrentRow(item)
          this.$nextTick(() => {
            document.querySelector('.monitor_right').querySelector('.el-table__body-wrapper').scrollTo(0, this.perRowHeight * index)
          })
        }
      })
    },
    changeSt (data, column) {
      this.stid = data.id
      this.stnm = data.stnm
      this.get5MYuRunData()
      // 地图联动
      this.$emit('showPoint', data)
      if (column.label === '站名') {
        this.$emit('showDialog', data)
      }
    },
    handleClick () {},
    sortMethod (a, b) {
      let bsort = (b.overflowWarningWater === undefined || b.overflowWarningWater === null) ? this.minSortNum - 1 : b.overflowWarningWater
      let asort = (a.overflowWarningWater === undefined || a.overflowWarningWater === null) ? this.minSortNum - 1 : a.overflowWarningWater
      return bsort - asort
    },
    // 获取河道信息
    getStatisticsRiverWater () {
      this.loading1 = true
      api.getStatisticsRiverWater({
        SID: this.$store.state.sid,
        StationName: this.staname
      }).then(async (res) => {
        this.loading1 = false
        let data = res.data.rows
        for (let i = 0; i < data.length; i++) {
          const el = data[i]
          if (el.stnm === '平阳站') {
            this.topWater = el.water
          }
        }
        // let result = await this.getLatestWaterLevel()
        // this.bomWater = result.rows[0].z
        this.tableData = data
        this.tableData.forEach((item, i) => {
          if (item.time) {
            // let arr = item.time.split(' ')
            // this.tableData[i].timeStr = arr[1]
            this.tableData[i].timeStr = item.time.slice(5)
          }
          if (item.addvnm) {
            let reg1 = new RegExp('镇', 'g')// g代表全部
            let reg2 = new RegExp('街道', 'g')// g代表全部
            let reg3 = new RegExp('岛管委会', 'g')// g代表全部
            this.tableData[i].addvnm = item.addvnm.replace(reg1, '').replace(reg2, '').replace(reg3, '')
          }
        })
        let filterWaterData = this.tableData.filter(item => { // 过滤数组中undefined及null类型
          return item.overflowWarningWater !== undefined && item.overflowWarningWater !== null
        })
        // 获取对象中属性的最小值
        let min = Math.min.apply(Math, filterWaterData.map(item => { return item.overflowWarningWater }))
        this.minSortNum = min
        this.tableData = this.tableData.sort((a, b) => {
          let bsort = (b.overflowWarningWater === undefined || b.overflowWarningWater === null) ? this.minSortNum - 1 : b.overflowWarningWater
          let asort = (a.overflowWarningWater === undefined || a.overflowWarningWater === null) ? this.minSortNum - 1 : a.overflowWarningWater
          return bsort - asort
        })
        this.$nextTick(() => {
          let temp = document.getElementsByClassName('el-table__row')
          this.perRowHeight = temp[0].offsetHeight
        })
        this.stid = data[0].id
        this.stnm = data[0].stnm
        this.get5MYuRunData()
      })
    },
    // 水位过程线
    get5MYuRunData () {
      this.loading3 = true
      api.get5MYuRunData({
        SID: this.$store.state.sid,
        STID: this.stid,
        EndTime: this.EndTime,
        BeginTime: this.BeginTime
      }).then(res => {
        this.loading3 = false
        let data = res.data
        this.drawLineChart(data, 'gcxlineChart')
      })
    },
    drawLineChart (data, htmlID) {
      let xData = []
      let waterData = []
      let wrzData = [] // 警戒水位
      let grzData = [] // 保证水位
      let waterMaxData = []// 用以比较
      data.runData_River.forEach(el => {
        let dateArr = el.date.split(' ')
        let date = dateArr[0].split('-')
        xData.push(date[1] + '-' + date[2] + ' ' + dateArr[1])
        if (el.guaranteeWater !== 0) {
          grzData.push(el.guaranteeWater)
        }
        if (el.alert !== 0) {
          wrzData.push(el.alert)
        }
        waterData.push(el.value)
        if (el.value) {
          waterMaxData.push(el.value)
        }
      })
      let ymin = Math.min(...waterMaxData)
      let ymax = Math.max(...waterMaxData)
      ymax = Math.max(ymax, grzData[0] ? grzData[0] : ymax, wrzData[0] ? wrzData[0] : ymax)
      ymin = Math.min(ymin, grzData[0] ? grzData[0] : ymin, wrzData[0] ? wrzData[0] : ymin)
      let gap = 1
      if (ymax && ymin) {
        gap = (ymax - ymin) / 2
      }
      ymin = Math.floor((ymin - gap / 2) * 10) / 10
      ymax = Math.floor((ymax + gap / 2) * 10) / 10
      let myChart = this.$echarts.init(document.getElementById(htmlID))
      myChart.clear()
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function (params, ticket, callback) {
            let htmlStr = ''
            for (var i = 0; i < params.length; i++) {
              let param = params[i]
              let xName = param.name// x轴的名称
              let seriesName = param.seriesName// 图例名称
              let value = param.value// y轴值
              let color = param.color// 图例颜色
              let danwei = 'mm'
              if (seriesName === '雨量') {
                danwei = 'mm'
              } else {
                danwei = 'm'
              }
              if (i === 0) {
                htmlStr += xName + '<br/>'// x轴的名称
              }
              htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                ${seriesName}：${value === undefined ? '-' : value}${danwei}
              </div>`
            }
            return htmlStr
          }
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          top: '18%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: xData,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            },
            formatter: function (params) {
              let arr = params.split(' ')
              let newParamsName = arr[1] + '\n' + arr[0]
              return newParamsName
            }
          }
        }],
        yAxis: [
          {
            min: ymin, // ymin
            max: ymax, // ymax
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              lineStyle: {
                opacity: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: '水位',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: waterData,
            itemStyle: {
              color: '#1B9ED6'
            },
            lineStyle: {
              normal: {
                color: '#1B9ED6',
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 设置线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgb(31,111,239,1)'
                    },
                    {
                      offset: 1,
                      color: 'rgb(31,111,239,0)'
                    }
                  ],
                  globalCoord: false // 缺省为 false
                },
                origin: 'start'
              }
            }
          },
          {
            name: '警戒水位',
            type: 'line',
            itemStyle: {
              color: 'orange'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: 'yellow',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M74.928386 877.529406l874.143197 0L512.002417 147.039827 74.928386 877.529406zM74.928386 877.529406z',
              symbolSize: [12, 8],
              symbolOffset: [40, 8],
              label: {
                position: [15, 0],
                color: '#fff',
                formatter: `警戒水位: ${wrzData[0]}m`
              }
            },
            data: wrzData
          },
          {
            name: '保证水位',
            type: 'line',
            itemStyle: {
              color: '#E02020'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: '#E02020',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M65.582671 288.791335l446.417329 446.41733 446.417329-446.41733z',
              symbolSize: [12, 8],
              symbolOffset: [40, -8],
              label: {
                position: [15, 0],
                color: '#fff',
                formatter: `保证水位: ${grzData[0]}m`
              }
            },
            data: grzData
          }
        ]
      })
    },
    reservoirWaterRowClass ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        return 'warning-red-row'
      }
      return ''
    },
    warningTimeStyle ({ row, column, rowIndex, columnIndex }) {
      let stylejson = {
        'color': 'yellow'
      }
      if (row.time) { // 时间超过30分钟为异常数据
        let time = row.time.replace(/-/g, '/')
        let date = new Date(time)
        time = date.getTime()
        let now = new Date().getTime()
        if ((now - time) / 1000 / 60 > 30) {
          return stylejson
        }
      } else {
        return stylejson
      }
      return ''
    },
    getCurrentTime (num) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000 * Number(num))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (mm > 9 ? mm : '0' + mm)
      return time
    }
  },
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.EndTime = this.getCurrentTime(0)
    this.BeginTime = this.getCurrentTime(1)
    this.getStatisticsRiverWater()
    this.$nextTick(() => {
      if (window.innerWidth >= 1600) {
        this.cellWidth = 'auto'
      } else {
        this.cellWidth = '60'
      }
      let toptable = this.$refs.toptable
      this.tableHeight = toptable.offsetHeight
    })
    this.timer = setInterval(() => {
      this.EndTime = this.getCurrentTime(0)
      this.BeginTime = this.getCurrentTime(1)
      this.getStatisticsRiverWater()
    }, 1000 * 60 * 5)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang='less' scoped>
*{
  box-sizing: border-box;
}
.monitor_right{
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 400;
  width: 520px;
  height: calc(100% - 85px);
  color: #fff;
  // background-image: linear-gradient(269deg, rgba(0,23,84,0.00) 0%, rgba(0,36,116,0.85) 100%);
  background-color: #1e346a;
  transition: all 1s ease;
}
.topDiv{
  width: 100%;
  height: calc(100% - 8.875rem);
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    background: rgba(0,0,0,0.2);
  }
}
.centerDiv{
  width: 100%;
  height: 285px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    padding: 3px 5px;
    background: rgba(0,0,0,0.2);
    display: flex;
    position: relative;
    .reservoirDiv{
      width: 100%;
      height: 100%;
      .duanmianChart{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
      }
      .duanmianDiv{
        width: 96px;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 180px;
        margin: auto;
        z-index: 100;
        img{
          // width: 100%;
          height: 100%;
        }
      }
      .chartname{
        position: absolute;
        font-size: 14px;
        left: 10px;
        bottom: 10px;
      }
      .overrun{
        height: 24px;
        line-height: 24px;
        padding: 0 5px;
        position: absolute;
        font-size: 14px;
        left: 80px;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #e02020;
      }
      #centerleftchart{
        width: calc(100% - 230px);
        height: 100%;
      }
      #centerrightchart{
        width: 230px;
        height: 100%;
      }
    }
    .riverDiv{
      width: 100%;
      height: 100%;
      #gcxlineChart{
        width: 100%;
        height: 100%;
      }
      .chartname{
        height: 20px;
        font-size: 14px;
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
    .changetab{
      position: absolute;
      right: 10px;
      top: 0;
      /deep/ .el-tabs__nav {
        line-height: 20px;
      }
      /deep/ .el-tabs__item{
        color:#fff;
        height: 20px;
        padding: 0 5px;
        line-height: 20px;
      }
      /deep/ .el-tabs__nav-wrap::after{
        background: none;
      }
      /deep/ .el-tabs__active-bar{
        background-color: #edde03;
      }
    }
  }
}
.bomDiv{
  width: 100%;
  height: 240px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    .chart-1,.chart-2{
      width: 100%;
      height: 100%;
      padding: 5px 0 0;
      position: relative;
      display: flex;
      align-items: flex-end;
      overflow: hidden;
    }
    .topcon{
      height: 50px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 20px;
      font-size: 14px;
      .title{
        background: #3C6EFB;
        line-height: 32px;
        padding: 0 10px;
      }
      .iconimg{
        background: #162c60;
        height: 32px;
        padding-left: 10px;
        img{
          height: 20px;
          padding-right: 10px;
        }
      }
    }
    #cwlineChart{
      height: 100%;
      width: 100%;
    }
    .shuizhaDiv{
      width: 111px;
      height: calc(100% - 40px);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      z-index: 100;
      img{
        // width: 100%;
        height: 100%;
      }
    }
    #bomleftchart{
      width: 50%;
      height: calc(100% - 30px);
    }
    #bomrightchart{
      width: 50%;
      height: calc(100% - 30px);
    }
  }
}
.showBtn{
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  left: -30px;
  top: 50px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i{
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .tran180{
    transform: rotate(180deg);
  }
}
.showMapBtn {
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  right: 520px;
  top: 100px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i {
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .navMain {
    padding: 15px 5px;
    /deep/ .el-radio {
      padding: 15px;
      display: block;
      font-size: 18px;
      margin-left: 25px;
      .el-radio__input.is-checked+.el-radio__label {
        color: #409EFF;
      }
      .el-radio__inner {
        width: 18px;
        height: 18px;
      }
    }
    /deep/ .el-radio__label {
      padding-left: 15px;
      font-size: 18px;
      color: #fff;
    }
  }
}
.radioOpen {
  width: 150px;
  height: auto;
}
.closeBtn {
  right: -520px;
}
.titleDiv{
  height: 48px;
  line-height: 48px;
  padding-left: 30px;
  padding-right: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(60,110,251,1) , rgba(60,110,251,0)) 10;
  .title{
    font-size: 22px;
    height: 50px;
    align-items: center;
  }
  .more{
    font-size: 16px;
    cursor: pointer;
    /deep/ .el-radio-button__inner{
      color:#fff!important;
      background: rgba(0,0,0,0);
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      border-radius: 0;
    }
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background: #1f6fef;
    }
    // /deep/ .el-input__inner{
    //   width: 120px;
    //   padding: 0;
    //   background: none;
    //   color: #fff;
    //   border: 0;
    //   text-align: center;
    // }
  }
  .title_logo{
    height: 50px;
    margin-right: 10px;
    img{
      height: 20px;
    }
  }
  .icon{
    display: flex;
    height: 50px;
    align-items: center;
    margin-right: 10px;
    transform: skew(-31deg);
    div{
      &:nth-of-type(1){
        width: 15px;
        height: 18px;
        background: #3C6EFB;
      }
      &:nth-of-type(2){
        width: 10px;
        height: 18px;
        background: #F7E700;
      }
    }
  }
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}

/deep/ .el-table{
  background: none!important;
  .cell{
    padding: 0;
  }
}

/deep/ .el-table__body tr.current-row>td{
  background-color: #69A8EA !important;
  color: #fff;
}
/deep/.el-table__empty-text{
  color: #fff;
}
/deep/.el-table tr {
  background-color: rgba(0,0,0,0);
}
/deep/ .el-table th{
  color: #fff;
  padding: 5px 0;
  background: #3C6EFB;
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}
/deep/ .el-table td{
  color: #fff;
  font-size: 13px;
  background: rgba(23,44,93,0.8);
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}

/deep/ .el-table .warning-red-row td{
  background: #d81539 !important
}
/deep/ .el-table--border{
  border: 1px solid #101e3e;
}
/deep/ .el-table--border::after,.el-table::before{
  background: none;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background: #0a37a0;
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}
.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexC {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flexFS {
  /* 左对齐 */
  justify-content: flex-start;
}

.flexFE {
  /* 右对齐 */
  justify-content: flex-end;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}

.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}

/deep/ ::-webkit-scrollbar{
  width: 0px;
  height: 7px;
  background-color: rgba(0,0,0,0);
}
// 测站查询框样式
.townSearch .el-input {
  display: inline-block;
  position: relative;
  top: 0rem;
  // right: 0.2rem;
  width: 180px;
}
.townSearch /deep/ .el-input__inner {
  background-color: transparent;
  border: 0.03125rem solid #079eb6;
  color: #ddd;
}
.townSearch /deep/ .el-input__inner:hover {
  border-color: #079eb6;
}
</style>
